module.exports = __webpack_public_path__ + "static/media/beonair-logo-w.5ba228e1.png";